import React, { useState, useEffect, useRef } from "react";
import { useObjectStore, bringToArtboard } from "../zustand/objects";
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from "@mui/icons-material/Delete"
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Stack from '@mui/material/Stack';
import Grid2 from '@mui/material/Grid2';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

import {editor} from "../styleFile.js"

// MANTINE
import classes from './BadgeCard.module.css';
import { Card, LoadingOverlay, Input, Text, Group, Badge, ActionIcon, useMantineTheme } from '@mantine/core';


import { Screenshot } from "../components/Screenshot";
import { isMobile } from 'react-device-detect';
import debounce from 'lodash.debounce';

import { View } from "@react-three/drei";
import { Canvas, useThree, useFrame } from "@react-three/fiber";

const ArtboardPanel = ({ projectKey }) => {
  const {
    storyboardFields,
    artboards,
    removeArtboard,
    currentObjectArtboard,
    updateArtboardAndPreviewCamera,
    updateObjectSelected,
    addArtboardPositional,
    copyArtboardPositional,
    updateStoryboardFields,
    screenshotStatus,
    moveArtboard,
    setScreenshotStatus,
    arrangeUndoRedo
  } = useObjectStore();

  // const bringUsersHere = () => {
  //   bringToArtboard(currentObjectArtboard)
  // }

  const [artboardViewing, setArtboardViewing] = useState()
  const [editingName, setEditingName] = useState('')

  useEffect(() => {
    setArtboardViewing(currentObjectArtboard)
  }, [currentObjectArtboard])

  // Delay function that returns a promise
  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const cycleFunction = async () => {
    const artboardKeys = Object.keys(artboards);

    for (let i = 0; i <= artboardKeys.length + 1; i++) {
      const val = artboardKeys[i];
      // console.log(val);

      if (i <= artboardKeys.length) {
        // updateArtboard(val);
        setArtboardViewing(val);
      } else {
        setScreenshotStatus(false);
        setArtboardViewing(currentObjectArtboard);

      }

      // Await the delay of 1000ms before moving to the next iteration
      await delay(2400);
    }
  };


  useEffect(() => {
    screenshotStatus && cycleFunction()
  }, [screenshotStatus])


  const handleChange = debounce((artboard, fieldType, value) => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "artboardUpdate",
      undo: false,
      projectKey: projectKey,
      artboard: artboard
    })
    // send update to zustand
    updateStoryboardFields(artboard, fieldType, value)

  }, 500)


  const handleSubmit = (e) => {
    e.preventDefault()
    e.target[0].blur()
  }

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return
    }
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "artboardMove",
      undo: false,
      projectKey: projectKey,
      artboard: currentObjectArtboard
    })
    // send update to zustand
    moveArtboard(source.index, destination.index)
  }

  const [snapping, setSnapping] = useState(null)

  const updateScreenshotArtboard = () => {
    snapping === artboards.length ? setSnapping(null) : setSnapping(snapping + 1)
  }

  const theme = useMantineTheme();

  return <>
    <div style={editor.artboardTopLevelContainer}>
      <div>
        <Grid2 container direction="column" spacing={1} pb={0} mb={0}>
          <Group justify="space-between">
            <Text fw={1000} size="xs" c="dimmed" mb="sm">
              ALL SCENES</Text>
            <Badge size="sm" mb="sm" variant="light" color={'gray'}>{Object.keys(artboards).length} SCENES</Badge></Group>
          <DragDropContext
            onDragEnd={onDragEnd}
          >
            <Droppable droppableId="artboard-list" direction="vertical">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}>
                  {Object.keys(artboards).map((mapped, i) => (
                    <div key={i} >
                      {/* style={{ width: "auto" }} > */}
                      <Draggable key={i} index={i} draggableId={i.toString()}
                        >
                        {(provided) => (
                          <div {...provided.draggableProps} ref={provided.innerRef}>
                            <Grid2 key={i} item ml={1} mb={1.5} pl={0}>
                              <Card withBorder radius="md" p={0}
                                style={{
                                  borderColor: artboardViewing === mapped ? theme.colors.primary[5] : theme.colors.secondary[3],
                                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)', // shadow-md
                              }}>

                                <Group wrap="nowrap" gap={0}  >
                                  <div {...provided.dragHandleProps} style={editor.artboardCardContents}>
                                    <Text c={currentObjectArtboard === mapped ? "#424242" : "#868e96"}><DragIndicatorIcon fontSize="small" /></Text>
                                  </div>
                                  <div>
                                    {(artboardViewing === mapped) ? <div style={editor.artboardViewingScreenshot}>
                                      <Screenshot index={i} updateScreenshotArtboard={updateScreenshotArtboard} snapping={0} projectKey={projectKey} guestMode={false} artboard={mapped} /></div>
                                      :
                                      <div
                                        style={editor.artboardNotViewingScreenshot}
                                        onClick={() => {
                                          updateObjectSelected('0')
                                          updateArtboardAndPreviewCamera(mapped);
                                          setArtboardViewing(mapped);
                                        }}
                                        size="small" />}
                                  </div>
                                  <div style={{ paddingLeft: 10 }}>
                                    {editingName === mapped ?
                                      <form onSubmit={(e) => handleSubmit(e)}>
                                        <Input
                                          style={{ width: 85 }}
                                          type='text'
                                          autoFocus
                                          defaultValue={storyboardFields[mapped].name ? storyboardFields[mapped].name : 'Name'}
                                          onChange={(e) => handleChange(mapped, 'name', e.target.value)}
                                          onBlurCapture={() => setEditingName('')}

                                        />
                                        <Input type="submit" hidden />
                                      </form>
                                      :
                                      <Text fw={currentObjectArtboard === mapped && 500} size={'xs'}
                                        c={currentObjectArtboard === mapped ? "#424242" : "#868e96"}
                                        style={editor.artboardNameText}
                                        onClick={() => {
                                          setEditingName(mapped)
                                        }}>
                                        {mapped}{storyboardFields[mapped].name ? ": " + storyboardFields[mapped].name : " Name"}
                                      </Text>}
                                    <Stack direction="row" >
                                      <ActionIcon
                                        onClick={() => {
                                          // send current state to undoActions
                                          arrangeUndoRedo({
                                            updateType: "artboardAdd",
                                            undo: false,
                                            projectKey: projectKey,
                                            artboard: currentObjectArtboard
                                          })
                                          // send update to zustand
                                          addArtboardPositional(mapped)
                                        }}
                                        radius={32}
                                        color={currentObjectArtboard === mapped ? "#424242" : "#868e96"}
                                        size={16}
                                        variant="filled"
                                        style={editor.artboardActionIcon}>
                                        <AddIcon fontSize="small" />
                                      </ActionIcon>
                                      <ActionIcon
                                        onClick={() => {
                                           // send current state to undoActions
                                           arrangeUndoRedo({
                                            updateType: "artboardAdd",
                                            undo: false,
                                            projectKey: projectKey,
                                            artboard: currentObjectArtboard
                                          })
                                          // send update to zustand
                                          copyArtboardPositional(mapped);
                                        }}
                                        color={currentObjectArtboard === mapped ? "#424242" : "#868e96"}
                                        size={16}
                                        variant="transparent"
                                        style={editor.artboardActionIcon}>
                                        <ContentCopyIcon fontSize="small" />
                                      </ActionIcon>
                                      <ActionIcon
                                        disabled={currentObjectArtboard == mapped}
                                        onClick={() => {
                                           // send current state to undoActions
                                           arrangeUndoRedo({
                                            updateType: "artboardRemove",
                                            undo: false,
                                            projectKey: projectKey,
                                            artboard: currentObjectArtboard
                                          })
                                          removeArtboard(mapped, false)
                                        }}
                                        color={currentObjectArtboard === mapped ? "#424242" : "#868e96"}
                                        size={16}
                                        variant="transparent"
                                        style={editor.artboardActionIcon}>
                                        <DeleteIcon fontSize="small" />
                                      </ActionIcon>
                                    </Stack>

                                  </div>
                                </Group>
                              </Card>
                            </Grid2>
                          </div>)}
                      </Draggable></div>
                  ))}
                  {provided.placeholder}
                </div>

              )}
            </Droppable>
          </DragDropContext>
        </Grid2></div>
    </div>
  </>;
};

export default ArtboardPanel;















